import '../styles/public.scss'

import '../public'

function requireAll(r) {
  r.keys().forEach(r)
}
requireAll(require.context('../images/', true, /\.png$/))
